// BabyMobile.ca — wires our custom "Add to cart" markup (product form + card
// pill buttons) into Shopify's real cart via AJAX, then opens Horizon's
// native cart drawer the same way its own product-form-component does.
(function () {
  function cartSectionId() {
    var el = document.querySelector('cart-items-component');
    return el ? el.dataset.sectionId : null;
  }

  function dispatchCartUpdate(data, sourceId, itemCount, productId, sections) {
    var event = new Event('cart:update', { bubbles: true });
    event.detail = {
      resource: data,
      sourceId: sourceId,
      data: {
        source: 'product-form-component',
        itemCount: itemCount,
        productId: productId,
        sections: sections || {},
      },
    };
    document.dispatchEvent(event);
  }

  function addToCart(formData, sourceId, itemCount, productId, onDone) {
    var sectionId = cartSectionId();
    if (sectionId) formData.append('sections', sectionId);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) {
          window.alert(data.message || 'Could not add that to your cart.');
          return;
        }
        var sections = {};
        if (sectionId && data.sections && data.sections[sectionId]) {
          sections[sectionId] = data.sections[sectionId];
        }
        dispatchCartUpdate(data, sourceId, itemCount, productId, sections);
      })
      .catch(function (err) {
        console.error(err);
        window.alert('Something went wrong adding that to your cart.');
      })
      .finally(function () {
        if (onDone) onDone();
      });
  }

  // Full product form (product page "Add to cart")
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.rd-product-form');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    var quantityField = formData.get('quantity');
    var quantity = quantityField ? parseInt(quantityField, 10) : 1;

    addToCart(formData, form.id || 'rd-ajax-cart-form', quantity, form.dataset.productId, function () {
      if (submitBtn) submitBtn.disabled = false;
    });
  });

  // Simple "Add" pill buttons on cards (bestsellers, catalog, related, quick view)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rd-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.adding === 'true') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.dataset.adding = 'true';
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    addToCart(formData, btn.id || 'rd-ajax-add-pill', 1, btn.getAttribute('data-product-id'), function () {
      btn.dataset.adding = 'false';
      btn.textContent = originalText;
    });
  });
})();
